module.exports = __webpack_public_path__ + "static/media/Lib2.b7f5940c.jpg";